import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../app';
import { QUICK_START } from '../types/localStorage';
import { logout } from './authSlice';

interface IState {
  visibleQuickStart: boolean;
  step: number[] | undefined;
}

const initialState: IState = {
  visibleQuickStart: !!JSON.parse(localStorage.getItem(QUICK_START) as string)
    ?.visibleQuickStart,
  step: JSON.parse(localStorage.getItem(QUICK_START) as string)?.step || [],
};

const quickStartSlice = createSlice({
  name: 'quickStart',
  initialState,
  reducers: {
    ChangeStatusQuickStart(state) {
      state.visibleQuickStart = !state.visibleQuickStart;

      localStorage.setItem(
        QUICK_START,
        JSON.stringify({
          visibleQuickStart: state.visibleQuickStart,
          step: state?.step,
        })
      );
    },
    setStep(state, action) {
      if (!state?.step?.includes(action.payload)) {
        state?.step?.push(action.payload);

        localStorage.setItem(
          QUICK_START,
          JSON.stringify({
            visibleQuickStart: state.visibleQuickStart,
            step: state?.step,
          })
        );
      }
    },
    resetQuickStartStep(state) {
      localStorage.removeItem(QUICK_START);

      state.step = [];
    },
  },
  extraReducers: builder => {
    builder.addCase(logout.fulfilled, state => {
      localStorage.removeItem(QUICK_START);

      state.step = [];
    });
  },
});

const { actions, reducer: quickStartReducer } = quickStartSlice;

export const { ChangeStatusQuickStart, setStep, resetQuickStartStep } = actions;
export default quickStartReducer;

export const selectQuickStart = (state: RootState): IState =>
  state.quickStart as IState;
